/**
 * Lets non-React code (API mappers, export helpers) read the current display currency
 * after the app has hydrated `DisplayCurrencyProvider`.
 */
let syncedDisplayCurrency = "USD";

export function setSyncedDisplayCurrency(code: string): void {
  syncedDisplayCurrency = (code || "USD").toUpperCase();
}

export function getSyncedDisplayCurrency(): string {
  return syncedDisplayCurrency;
}
